import PreAlertRuleFormatter from "_components/PreAlertRuleFormatter";
import { getIcons } from "_helpers";
import { contextActions, preAlertActions } from "_store";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
export { AlertOverview };

/**
 * Composant d'affichage d'une pré-alerte
 * S'affiche sur la partie droite de l'écran listant les pré-alertes
 * @returns 
 */
function AlertOverview() {

    const dispatch = useDispatch();
    const preAlert = useSelector(state => state.preAlerts?.item);
    const contextDetails = useSelector(state => state.contextDetails)

    useEffect(() => {
        if (!preAlert) {
            dispatch(preAlertActions.getAll());            
        }
        if (!contextDetails.data && !contextDetails.isLoading){
            dispatch(contextActions.getContextDetail())
        }
    }, []);

    return(
        (preAlert ? (
        <div className="filter-view">
            <div className="filter-view-header">
                <div className="filter-header-row">
                    <div className="filter-title"><strong>{preAlert.name}</strong></div>
                    <div className="filter-date">
                        <img src={getIcons('accessTimeOutlinedGrey')} alt='icone parametres' />
                        Créé le: {new Date(preAlert.creation_date).toLocaleDateString()}
                    </div>
                </div>  
                <div className="filter-description"><strong>Description:</strong> {preAlert.description}</div>
            </div>
           <div className="filter-view-body">
                <div className="filter-section-title">
                    <img src={getIcons('constructionOutlinedGrey')} alt='icone parametres' />
                    Critères
                </div>
                <PreAlertRuleFormatter rules={preAlert.rules} contextDetails={contextDetails}/>
                <div className="filter-section-title">
                    <img src={getIcons('emailOutlined')} alt='icone parametres' />
                    Emails
                </div>
                <div className="rules">
                    {preAlert.emails.map((item, index) => (
                        <p key={index}>{item}</p>
                    ))}
                </div>
           </div>   
        </div>
        ) : (
        <div className="flex items-center justify-center h-full">
            <p className="text-4xl font-extralight text-global-grey text-center">
                Sélectionnez<br/>
                une pré-alerte pour<br/>
                en voir les détails
            </p>
        </div>)
        )
    )
}